import apiClient from './api';
import type {
  Organization,
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
  OrganizationSearchParams,
} from '../types/organization';
import type { PagedResponse } from '../types/common';

export const organizationService = {
  search: async (companyId: number, params?: OrganizationSearchParams): Promise<PagedResponse<Organization>> => {
    const response = await apiClient.post<PagedResponse<Organization>>('/organizations/search', {
      companyId,
      search: params?.search,
      includeArchived: params?.includeArchived ?? false,
      page: params?.page ?? 0,
      size: params?.size ?? 20,
      sortBy: params?.sortBy ?? 'id',
      sortDir: params?.sortDir ?? 'asc',
    });
    return response.data;
  },

  listAllActive: async (companyId: number): Promise<Organization[]> => {
    const page = await organizationService.search(companyId, { size: 500 });
    return page.content;
  },

  getById: async (organizationId: number): Promise<Organization> => {
    const response = await apiClient.get<Organization>(`/organizations/${organizationId}`);
    return response.data;
  },

  create: async (data: CreateOrganizationRequest): Promise<Organization> => {
    const response = await apiClient.post<Organization>('/organizations', data);
    return response.data;
  },

  update: async (organizationId: number, data: UpdateOrganizationRequest): Promise<Organization> => {
    const response = await apiClient.put<Organization>(`/organizations/${organizationId}`, data);
    return response.data;
  },

  delete: async (organizationId: number): Promise<void> => {
    await apiClient.delete(`/organizations/${organizationId}`);
  },

  restore: async (organizationId: number): Promise<void> => {
    await apiClient.post(`/organizations/${organizationId}/restore`);
  },
};
